import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { EstoqueAmpService } from '../estoque-amp-service/estoque-amp.service';
import { CrudBase } from '././../../../../shared/crud/CrudBase';
import { ListitemBuilder } from '././../../../../shared/dropdown-list/ListItemBuilder';
import { FiltroService } from '././../../../../shared/filtro/filtro.service';
import { Estado } from '././../../../../shared/shared/estado.enum';
@Component({
  selector: 'app-estoque-amp-cadastro',
  templateUrl: './estoque-amp-cadastro.component.html',
  styleUrls: ['./estoque-amp-cadastro.component.css']
})
export class EstoqueAmpCadastroComponent extends CrudBase implements OnInit {

  itensTipo: any;
  dealer: any;
  meses: any;
  todos = false;
  carregando = false;

  constructor(service: EstoqueAmpService,
    private filtroService: FiltroService,
    toastr: ToastrService) {
    super(service, toastr);
  }
  
  ngOnInit() {
    if (!this.model) {
      this.model = {}
    }
    this.defineModelVazio();
    this.carregarMeses();
  }

  novo() {
    super.novo()
    this.defineModelVazio();
  }

  salvar() {
    if (this.todos){
      this.filtroService.buscar("dealer").then(res =>{
        for (const filtro of res.filtros) {
          this.model.id_dealer = filtro.id.toString();
          super.salvar();
        }
      });
    }else{
      super.salvar();
    }
    
  }

  todosdelaer(){
    this.carregando = true;
    this.todos = !this.todos;
    this.model.id_dealer = 1;
    this.carregando = false;
  }

  private defineModelVazio() {
    if (this.state === Estado.insert) {
      this.model.id = null;
      this.model.id_dealer = '';
    }
  }

  private carregarMeses() {
    this.meses =
    new ListitemBuilder()
      .add('1', 'Janeiro')
      .add('2', 'Fevereiro')
      .add('3', 'Março')
      .add('4', 'Abril')
      .add('5', 'Maio')
      .add('6', 'Junho')
      .add('7', 'Julho')
      .add('8', 'Agosto')
      .add('9', 'Setembro')
      .add('10', 'Outubro')
      .add('11', 'Novembro')
      .add('12', 'Dezembro')
      .build();
  }
  
  Uploader(event) {
    const json = this.convertExcelToJson(event);    
  }
  
  convertExcelToJson(ev) {
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.files[0];

    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      this.insertArquivo(JSON.stringify(jsonData));
    }
    reader.readAsBinaryString(file);
  }

  insertArquivo(json){

    var row = JSON.parse(json)
    var verifica = this.verificaArquivo(row);
    if(verifica){
      for(let i = 0; i < row.NBS.length; i++ ) {
      
        if(typeof row.NBS[i].dealer === "undefined" || typeof row.NBS[i].partnumber  === "undefined" || typeof row.NBS[i].quantidade  === "undefined"){
            alert('Arquivo com erro na linha ' + (i+2));
        }else{
          this.model.id = "0";
          this.model.id_dealer = row.NBS[i].dealer.toString();
          this.model.partNumber = row.NBS[i].partnumber.toString();
          this.model.quantidade = row.NBS[i].quantidade.toString();
          super.salvar();
          this.defineModelVazio();
        }
      
      }
    }
  }

  verificaArquivo(row){
    var teste = [];
    for (const nbs of row.NBS) {
      teste.push(nbs.dealer?.toString() + nbs.partnumber?.toString());
    }
    if(!this.hasDuplicates(teste)){
      return true;
    }else{
      const mensagem = 'Arquivo Com Itens Duplicados';
      this.toastr.error(mensagem, 'Erro no Arquivo');
    }
    
  }

  hasDuplicates(array) {
    return (new Set(array)).size !== array.length;
  }

}
